module.exports = __webpack_public_path__ + "static/media/Salve Product Photo (2 Jars)-11-25percent.54e8b0ea.svg";